import React from 'react'
import { castArray } from 'lodash-es'

const Text = function ({ value }) {
  const { origin } = value
  return (
    <div className="w-full flex flex-row flex-nowrap gap-1">
      {(origin || []).map((item) => {
        const content = item.coordinates
          ? castArray(item.coordinates).join(',')
          : ''
        return (
          <div
            key={content}
            style={{
              background: 'var(--ow-color-neutral-100)',
              borderRadius: '4px',
              padding: '2px 8px',
            }}
          >
            <span>{content}</span>
          </div>
        )
      })}
    </div>
  )
}

export default Text
